import { InitialFormData } from "./types";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useSearchParams } from "react-router-dom";

import AuthButton from "../../../../components/AurhButton";
import Divider from "../../../../components/Divider";
import { EnvelopeIcon } from "../../../../components/Icons";
import Input from "../../../../components/Input";
import SocialAuthButtons from "../../../../components/SocialAuthButtons";
import useAuth from "../../../../hooks/useAuth.tsx";
import { validationSchema } from "./schema";

import { AuthStepComponentProps } from "../../types.ts";
import { LoginStep } from "../types.ts";
import { useState } from "react";

const Initial = ({
  setStep,
  email,
  setEmail,
  isAuthorizing,
}: AuthStepComponentProps<LoginStep>) => {
  const { isLoggedIn } = useAuth();
  const [searchParams] = useSearchParams();

  const refCode = searchParams.get("refCode") || "";
  const [isChecked, setIsChecked] = useState(true);
  const [checkboxError, setCheckboxError] = useState("");

  const {
    clearErrors,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<InitialFormData>({
    resolver: yupResolver<InitialFormData>(validationSchema),
    defaultValues: {
      email,
    },
  });

  const onSubmit = (data: InitialFormData) => {
    if (!isChecked) {
      setCheckboxError("Must accept terms & conditions");
      return;
    }
    setCheckboxError("");
    setStep("password");
    setEmail?.(data.email);
  };

  const queryParams = new URLSearchParams(location.search).toString();
  let signupUrl = "/auth/signup";
  if (!isLoggedIn) {
    signupUrl = `/auth/signup${queryParams ? `?${queryParams}` : ""}`;
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="appearAnimation">
        <Input
          name="email"
          autoFocus
          control={control}
          autoComplete={"email"}
          placeholder="Enter email"
          error={errors.email?.message}
          Icon={EnvelopeIcon}
          disabled={isAuthorizing}
          clearErrors={clearErrors}
        />

        <AuthButton className={"mt-[1.25rem]"} disabled={isAuthorizing} />

        <div className="flex items-center space-x-2 mt-3">
          <input 
            id="accept-terms" 
            type="checkbox" 
            className="h-4 w-4 rounded" 
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            style={{ accentColor: '#5ed8b2' }} 
          />
          <label htmlFor="accept-terms" className="text-sm text-gray-700">
            By logging in you are accepting our{" "}
            <Link to="/auth/terms" className="text-primary-400 dark:text-primary-300 capitalize">
              terms and conditions
            </Link>
          </label>
        </div>

        {checkboxError && (
          <p className="text-sm text-red-500 mt-2">{checkboxError}</p>
        )}
      </form>

      <p className="appearAnimation flex items-center justify-center gap-[1rem] font-Mulish text-[0.875rem] leading-[1.29rem] text-neutral-400 dark:text-white/50">
        Don&#39;t have an account?
        <Link to={signupUrl} className="text-black dark:text-primary-300 underline">
          Sign up
        </Link>
      </p>

      <Divider />
      <SocialAuthButtons isAuthorizing={isAuthorizing} refCode={refCode} />
    </>
  );
};

export default Initial;
